(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/pix-banner/views/turnover.js') >= 0) return;  svs.modules.push('/components/racing/pix-banner/views/turnover.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.racing=_svs.racing||{};
_svs.racing.pix_banner=_svs.racing.pix_banner||{};
_svs.racing.pix_banner.templates=_svs.racing.pix_banner.templates||{};
svs.racing.pix_banner.templates.turnover = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div>\n      Jackpot: "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"jackpot") || (depth0 != null ? lookupProperty(depth0,"jackpot") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"jackpot","hash":{},"data":data,"loc":{"start":{"line":4,"column":15},"end":{"line":4,"column":26}}}) : helper)))
    + " kr\n    </div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"showNetSales") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data,"loc":{"start":{"line":8,"column":6},"end":{"line":12,"column":13}}})) != null ? stack1 : "")
    + "    </div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        Omsättning: "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"currentNetSales") || (depth0 != null ? lookupProperty(depth0,"currentNetSales") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"currentNetSales","hash":{},"data":data,"loc":{"start":{"line":9,"column":20},"end":{"line":9,"column":39}}}) : helper)))
    + " kr\n";
},"6":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"start-time\">Startar "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"startTimeToDisplay") || (depth0 != null ? lookupProperty(depth0,"startTimeToDisplay") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"startTimeToDisplay","hash":{},"data":data,"loc":{"start":{"line":11,"column":40},"end":{"line":11,"column":62}}}) : helper)))
    + "</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"pix-net-sale-info\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"jackpot") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":14,"column":9}}})) != null ? stack1 : "")
    + "</div>\n\n";
},"useData":true});
Handlebars.partials['components-racing-pix_banner-turnover'] = svs.racing.pix_banner.templates.turnover;
})(svs, Handlebars);


 })(window);